import styled from 'styled-components';

export const Container = styled.div`

`;

export const List = styled.div`
  display: grid;
  column-gap: 30px;
  row-gap: 48px;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
